<template>
  <div>
    <Login @login="withLogin = $event"/>
  
    <div class="row" v-if="withLogin">
      <div class="col-sm-6" v-for="page in pages" :key="page.name">
        <router-link tag="div" :to="`/unico_integration/${page.path}`" class="card card-admin">
          <div class="card-body text-center">
            <strong>
              {{ page.name }}
            </strong>
          </div>
        </router-link>
      </div>
    </div>
    
    <div v-else>
      <div class="row">
        <div class="col-md-12 text-center my-5">
          <h3>Conta sem login. Deve criar o login primeiro para ver outras configurações</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Login from '@/components/unico_integration/Login'
  
  export default {
    components: { Login },
    data: () => ({
      pages: [
        { name: 'Configurações', path: 'settings'},
        { name: 'Eventos', path: 'fiscal_document_events'},
      ],
      withLogin: false,
    }),
    name: 'Index'
  }
</script>

<style scoped>

  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }
  
</style>